// SPDX-License-Identifier: AGPL-3.0-or-later

import sharedStyles from '@app/features/channel/components/ExpressionPickerShared.module.css';
import type React from 'react';

interface PickerEmptyStateProps {
	icon: React.ComponentType<{className?: string}>;
	title: string;
	description: string;
}
export const PickerEmptyState = ({icon: Icon, title, description}: PickerEmptyStateProps) => (
	<div className={sharedStyles.emptyState}>
		<div className={sharedStyles.emptyStateContent}>
			<Icon className={sharedStyles.emptyStateIcon} />
			<div className={sharedStyles.emptyStateTextContainer}>
				<h3 className={sharedStyles.emptyStateTitle}>{title}</h3>
				<p className={sharedStyles.emptyStateDescription}>{description}</p>
			</div>
		</div>
	</div>
);
